<template>
  <div id="app" :class="{ [curTheme]: true }">
    <tour/>
    <nav-top/>
    <router-view/>
    <loading ref="loading"/>
  </div>
</template>

<script>
import Vue from 'vue';
import NavTop from './components/NavTop';
import Tour from './components/Tour';
import Loading from './components/Loading';

export default {
  name: 'App',

  components: { NavTop, Tour, Loading },

  created() {
    this.$store.dispatch('orgs/fetchOrgs');
    this.$store.dispatch('types/fetchTypes');
    this.$store.dispatch('user/tryAutoAuth');
    this.$store.dispatch('theme/setStoredTheme');
  },
  mounted() {
    Vue.$loading = this.$refs.loading;
    // Check if mobile device
    if (window.orientation !== undefined) {
      document.body.classList.add('is-mobile');
    }
  },
};
</script>

<style lang="scss">
@import "./styles/common/main";

html {
  position: relative;
  min-height: 100%;
  padding-bottom: 164px;
  @media (max-width: 1010px) {
    padding-bottom: 245px;
  }
  @media (max-width: 600px) {
    padding-bottom: 410px;
  }
  &.html_page-form {
    @extend .grad;
    a {
      color: #fff !important;
    }
    .theme-w .lite-button {
      color: #fff !important;
    }
    .page-footer_pfr.theme-w a {
      color: #333 !important;
    }
  }
}

body {
  min-height: 100%;
}

html, body {
  margin: 0;
  font-family: $font;
  font-size: 16px;
}

button {
  font-family: $font;
  background: transparent;
  border: none;
  padding: 0;
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: none !important;
}

a, a:hover {
  text-decoration: none;
  cursor: pointer;
}

::selection {
  background: rgba(255, 255, 255, .3);
}

::-moz-selection {
  background: rgba(255, 255, 255, .3);
}

.page-container_pcr {
  max-width: 1250px;
  width: 100%;
  padding: 0 25px;
  margin: 0 auto;
  @media (max-width: 767px) {
    padding: 0 15px;
  }
  &.pcr--border-bottom {
    border-bottom: 1px solid;
    padding-bottom: 40px;
  }
  &.pcr--xl {
    max-width: 1600px;
  }
}

.el-input,
.el-date-editor.el-input,
.el-select {
  width: 100%;
}

.block-wrap {
  margin: 15px auto;
  padding: 25px;
  clear: both;
  @include border-radius(12px);
  background: rgba(0, 0, 0, .20);
  @media(max-width: 500px) {
    padding: 25px 19px;
  }
  &.block-wrap_error {
    text-align: center;
    background: $error-color;
    color: #000;
  }
  &.block-wrap_message {
    text-align: center;
    border-radius: 5px;
    background: #9bd7a8;
    color: #000;
  }
  &.block-wrap_btns {
    background: transparent;
    padding: 25px 0;
    text-align: center;
    margin: 0 auto;
  }
  &:first-of-type {
    margin-top: 0;
  }
  .bw_block-title {
    font-size: 18px;
    color: #ededed;
    text-align: center;
    padding-bottom: 20px;
  }
  .bw_block-row {
    margin: 20px 0;
  }
  .el-checkbox {
    color: #fff;
    white-space: normal;
    .el-checkbox__input {
      position: absolute;
      &.is-checked+.el-checkbox__label {
        color: lighten($color-1, 25%);
      }
      &.is-focus .el-checkbox__inner {
        border-color: $color-1;
      }
    }
    .el-checkbox__label {
      padding-left: 25px;
    }
    &.is-checked .el-checkbox__inner {
      background: $color-1;
      border-color: $color-1;
    }
  }
}

.el-message-box {
  @include border-radius(10px);
  width: auto;
  max-width: 400px;
  .el-message-box__header {
    padding: 35px 15px 10px;
  }
  .el-button {
    border-radius: 20px;
  }
  .el-button {
    padding: 7px 30px;
  }
  .el-message-box__headerbtn .el-message-box__close {
    color: #000;
    &:hover {
      color: $color-1;
    }
  }
  .el-message-box__message {
    font-size: 16px;
    text-align: center;
    padding: 10px 20px;
    color: #000;
    p {
      line-height: 20px;
    }
  }
  .el-button--primary {
    cursor: pointer;
    border-radius: 20px;
    border: 1px solid #d74b88 !important;
    color: #333;
    @include transition;
    background: transparent;
    &:hover {
      color: #fff !important;
      @extend .grad;
      border: 1px solid transparent !important;
    }
  }
  .el-button--default {
    border: transparent;
    &:hover {
      background: transparent;
      color: $color-1;
    }
  }
  .el-input__inner {
    background: rgba(0, 0, 0, 0.05);
    color: #000 !important;
    &::-webkit-input-placeholder {
      color: #000 !important;
      opacity: .6;
      font-weight: 300;
    }
    &:-ms-input-placeholder {
      color: #000 !important;
      opacity: .6;
      font-weight: 300;
    }
    &::-moz-placeholder {
      color: #000 !important;
      opacity: .6;
      font-weight: 300;
    }
    &:-moz-placeholder {
      color: #000 !important;
      opacity: .6;
      font-weight: 300;
    }

  }
}

.el-select-dropdown {
  @include border-radius(2px);
  background: #fff;
  border: none;
  @include box-shadow(0 2px 20px rgba(0, 0, 0, .25));
  .el-scrollbar {
    @include border-radius(6px);
    overflow: hidden;
  }
  &.is-multiple .el-select-dropdown__item {
    white-space: normal;
    padding-right: 40px;
    &.selected {
      white-space: normal;
      color: $color-1;
    }
  }
  .el-select-dropdown__item {
    white-space: normal;
    height: auto;
    line-height: 27px;
    padding: 5px 20px;
    font-weight: 400;
    @include transition;
    .title,
    .fio {
      font-weight: bold;
    }
    span {
      line-height: 18px !important;
      display: inline-block;
      margin: 5px 0;
    }
    &.hover {
      background: #f5f5ff;
      color: #333;
    }
    &.selected {
      background: #eae8ff;
      color: #333;
    }
  }
}

.el-dropdown-menu {
  border: none;
  @include border-radius(8px);
  @include box-shadow(0 2px 20px rgba(0, 0, 0, .15));
  &.el-dropdown--no-links {
    .el-dropdown-menu__item {
      padding: 8px 20px;
    }
  }
  .el-dropdown-menu__item {
    line-height: 18px;
    /*padding: 8px 20px;*/
    padding: 0;
    a {
      color: #000 !important;
      display: block;
      padding: 8px 20px;
    }
    &:hover {
      background: #edecff;
      color: #333;
    }
  }
}

.el-tooltip__popper {
  font-size: 14px;
  line-height: 18px;
  max-width: 600px;
  font-weight: 400;
  padding: 15px;
  .tooltip-title {
    opacity: .5;
  }
  &.is-dark {
    background: #fff;
    color: #303133;
    @include box-shadow(0 4px 12px rgba(0, 0, 0, .15));
    .popper__arrow {
      border-top-color: #fff;
      border-bottom-color: #fff;
    }
    .popper__arrow:after {
      border-top-color: #fff;
      border-bottom-color: #fff;
    }
  }
}

.input-base-style {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  overflow: hidden;
}

.el-textarea__inner {
  padding: 8px 15px;
  overflow: hidden;
}

.el-range-input {
  @include border-radius(5px);
  background: rgba(0, 0, 0, .1);
  @include box-shadow(inset 0 3px 10px rgba(0, 0, 0, .2));
  color: #fff !important;
}
.el-range-separator {
  color: #fff !important;
  width: 10% !important;
}

.el-textarea__inner,
.input-base-style,
.el-input__inner {
  background: rgba(0, 0, 0, .2);
  @include box-shadow(inset 0 3px 10px rgba(0, 0, 0, .2));
  color: #fff;
  border: none;
  font-size: 16px;
  font-family: $font;
  @include border-radius;
  &:focus {
    border-color: #fff;
  }
  &::-webkit-input-placeholder {
    color: #fff !important;
    opacity: .6;
    font-weight: 300;
  }
  &:-ms-input-placeholder {
    color: #fff !important;
    opacity: .6;
    font-weight: 300;
  }
  &::-moz-placeholder {
    color: #fff !important;
    opacity: .6;
    font-weight: 300;
  }
  &:-moz-placeholder {
    color: #fff !important;
    opacity: .6;
    font-weight: 300;
  }
}

.el-textarea__inner {
  resize: none;
}

.buttons-wrap {
  text-align: center;
}

.trans-btn {
  padding: 12px 35px 9px;
  cursor: pointer;
  font-size: 13px;
  text-transform: uppercase;
  @include border-radius;
  @include transition(all, .5s);
  &.trans-btn_white {
    color: #fff;
    border: 1px solid rgba(255, 255, 255, .3);
    &:hover {
      background: rgba(255, 255, 255, .3);
      border-color: transparent;
    }
  }
}

.lite-button {
  padding: 12px 20px 9px;
  cursor: pointer;
  color: #fff;
  @include border-radius;
  font-size: 13px;
  text-transform: uppercase;
  border: 1px solid rgba(255, 255, 255, .3);
  @include transition(all, .5s);
  &:hover {
    background: $color-1;
    color: #fff !important;
    border-color: transparent !important;
  }
}
.theme-w {
  .lite-button {
    color: #000;
    border-color: #bbb;
    // border: transparent;
    // @include box-shadow(0 3px 20px 2px rgba(0, 0, 0, .1));
    &:hover {
      // @include box-shadow(0 3px 20px 2px rgba(215, 85, 135, .3));
    }
  }
}

.normal-button {
  padding: 12px 20px 9px;
  cursor: pointer;
  color: #fff;
  @include border-radius;
  font-size: 13px;
  text-transform: uppercase;
  border: 1px solid rgba(215, 75, 135, .8);
  background: transparent;
  @include transition(all, .5s);
  &.normal-button--on,
  &:hover {
    background: $color-1;
    color: #fff;
    border-color: transparent;
  }
}
.theme-w {
  .normal-button {
    color: #000;
    &:hover {
      color: #fff;
    }
  }
}

.vivid-button {
  color: #fff;
  border: none;
  padding: 12px 35px 9px;
  cursor: pointer;
  font-size: 13px;
  text-transform: uppercase;
  @include border-radius;
  background: linear-gradient(270deg, #6559de, #d74b88);
  background-size: 400% 400%;
  /*-webkit-animation: grad-animate 4s ease infinite;*/
  /*-moz-animation: grad-animate 4s ease infinite;*/
  /*-o-animation: grad-animate 4s ease infinite;*/
  /*animation: grad-animate 4s ease infinite;*/
  @include transition(all, .5s);
  &:hover {
    /*padding: 12px 45px 9px;*/
    color: #fff;
  }
  &.not-active, &[disabled], &:hover[disabled] {
    opacity: .3;
    background: linear-gradient(270deg, #6559de, #d74b88);
    color: #fff;
  }
}

.trans-button {
  color: #fff;
  border: none;
  padding: 12px 35px 9px;
  cursor: pointer;
  font-size: 13px;
  text-transform: uppercase;
  @include transition(opacity .3s);
  &:hover {
    opacity: .7;
  }
}

.sm-button {
  padding: 6px 10px 5px;
  font-size: 9px;
}

@-webkit-keyframes grad-animate {
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
}
@-moz-keyframes grad-animate {
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
}
@-o-keyframes grad-animate {
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
}
@keyframes grad-animate {
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
}

.el-message {
  background: #fff;
  border: none;
  @include border-radius(10px);
  .el-message__icon {
    color: #000;
    display: none;
  }
  .el-message__content {
    line-height: 20px;
    padding-right: 16px;
    color: #000;
    text-align: center;
    display: block;
    width: 100%;
  }
  &.is-closable {
    .el-message__content {
      padding-right: 24px;
    }
  }
}

.el-year-table td .cell {
  color: #606266 !important;
}

.depo-msg_dmg {
  padding: 100px 30px;
  text-align: center;
  border: 1px dashed #fff;
  margin: 100px 0;
  @include border-radius(25px);
  opacity: .4;
  .dmg_star {
    width: 200px;
    height: 100px;
    background: 50% 50% no-repeat url(../static/grx/icons/star.svg);
    background-size: contain;
    display: block;
    margin: 0 auto;
  }
  .dmg_icon {
    width: 200px;
    height: 100px;
    background: 50% 50% no-repeat url(../static/grx/icons/depo.svg);
    background-size: contain;
    display: block;
    margin: 0 auto;
  }
  .dmg_user {
    width: 200px;
    height: 100px;
    background: 50% 50% no-repeat url(../static/grx/icons/person-w.svg);
    background-size: contain;
    display: block;
    margin: 0 auto;
  }
  .dmg_draft {
    width: 200px;
    height: 100px;
    background: 50% 50% no-repeat url(../static/grx/icons/draft.svg);
    background-size: contain;
    display: block;
    margin: 0 auto;
  }
  .dmg_text {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 300;
    color: #fff;
    max-width: 500px;
    display: inline-block;
  }
  .dmg_plus {
    position: absolute;
    bottom: -55px;
    left: 50%;
    margin-left: -50px;
    width: 100px;
    height: 100px;
    background: 50% 50% no-repeat url(../static/grx/icons/depo-color.svg);
    background-size: contain;
    opacity: 1;
  }
  &.dmg_btn {
    opacity: .7;
    cursor: pointer;
    @include transition;
    position: relative;
    .dmg_icon {
      opacity: 1;
    }
    &:hover {
      opacity: .9;
    }
  }
  @media (max-width: 1000px) {
    margin: 40px 0;
  }
}

.no-results {
  text-align: center;
  font-size: 16px;
  margin-top: 90px;
  @media (max-width: 1000px) {
    margin-top: 40px;
  }
}

.el-input-number__increase {
  border-top-right-radius: 19px !important;
}

.el-input-number__decrease {
  border-bottom-right-radius: 19px !important;
}

.el-input-number__increase,
.el-input-number__decrease {
  background: rgba(255, 255, 255, .1);
  border-color: rgba(255, 255, 255, .1) !important;
  @include transition;
  i {
    color: #fff !important;
  }
  &:hover {
    background: rgba(255, 255, 255, .15);
  }
}

.el-switch__label {
  color: #bdbdbd;
}
.el-switch__core {
  background: rgba(0, 0, 0, .15) !important;
  border-color: rgba(0, 0, 0, .1) !important;
}
.el-switch__core:after {
  background-color: #ff84b1;
}
.el-switch__label.is-active {
  color: #ff84b1;
}

.el-upload.el-upload--text {
  @include border-radius;
}

.el-date-editor {
  .el-range-input {
    background: transparent;
    @include box-shadow(none);
  }
}
.el-date-table td.today span {
  color: $color-1;
}
.el-date-table td.available:hover {
  color: $color-1;
}
.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: $color-1;
}
.el-picker-panel__shortcut:hover {
  color: $color-1;
}
.el-date-table td.in-range div {
  background: #f3f3f3;
}
.el-picker-panel__icon-btn {
  &.is-disabled {
    opacity: .5;
  }
  &:hover {
    color: $color-1;
  }
}

.el-upload-list__item .el-icon-upload-success {
  color: #c6a4ff;
}

.el-upload-list__item:hover {
  background: rgba(255, 255, 255, .05);
  .el-icon-document,
  .el-upload-list__item-name {
    color: #fff !important;
  }
  .el-icon-close {
    color: #fff !important;
  }
}

.el-upload-list__item-name {
  color: #fff;
  .el-icon-document {
    color: #fff;
  }
}

.el-pagination {
  text-align: center;
  margin: 30px 0;
  white-space: normal;
  li,
  button {
    background-color: transparent !important;
    color: #fff !important;
  }
  li.active {
    color: #ff84b1 !important;
  }
  .el-pagination__jump {
    color: #999;
  }
  .el-input__inner {
    background: #333;
    color: #ff84b1;
    margin-left: 5px;
    border: none;
  }
  .el-pager {
    margin-bottom: 15px;
  }
}

.el-dialog {
  max-width: 500px;
  width: 95%;
  @include border-radius(12px);
  @mixin selection {
    background: rgba(0, 0, 0, .5);
    color: #fff;
  }
  ::selection {
    @include selection;
  }
  ::-moz-selection {
    @include selection;
  }
  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    font-size: 16px;
    line-height: 20px;
  }
  .el-dialog__title {
    color: $color-1;
  }
  .el-dialog__body {
    padding: 22px 40px;
    font-weight: 300;
    color: #000;
    word-break: normal;
    @media (max-width: 767px) {
      padding: 22px 22px;
    }
    a {
      color: $color-2 !important;
      &:hover {
        color: $color-1 !important;
      }
    }
    .el-input__inner,
    .el-textarea__inner {
      @include border-radius(8px);
      @include box-shadow(inset 0 3px 10px rgba(0, 0, 0, .1));
      background: #f6f6f6;
      color: #333;
      @mixin pholder {
        color: #000 !important;
        opacity: .4;
        font-weight: 400;
      }
      &::-webkit-input-placeholder {
        @include pholder;
      }
      &:-ms-input-placeholder {
        @include pholder;
      }
      &::-moz-placeholder {
        @include pholder;
      }
      &:-moz-placeholder {
        @include pholder;
      }
    }
    h2 {
      margin: 0 0 15px;
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      color: #000;
    }
    .el-checkbox {
      .el-checkbox__inner {
        border-color: #999;
      }
      .el-checkbox__label {
        color: #000;
      }
      &:hover {
        .el-checkbox__label {
          color: $color-1 !important;
        }
        .el-checkbox__inner {
          border-color: $color-1;
        }
      }
      .el-checkbox__input.is-checked {
        & + .el-checkbox__label {
          color: #000;
        }
        .el-checkbox__inner {
          border-color: $color-1;
        }
      }
    }
  }
  .el-dialog__close {
    color: #000;
    @include transition;
    &:hover {
      color: $color-1;
    }
  }
  .el-dialog__footer {
    text-align: center;
    .dialog-primary-btn,
    .dialog-close-btn {
      cursor: pointer;
      padding: 5px 30px;
      @include border-radius;
      border: 1px solid $color-1;
      color: #333;
      @include transition;
      &:focus {
        border: 1px solid $color-1;
        background: transparent;
      }
      &:hover {
        color: #fff;
        border-color: transparent;
        @extend .grad;
      }
    }
    .dialog-vivid-btn {
      cursor: pointer;
      padding: 6px 31px;
      @include border-radius;
      @extend .grad;
      color: #fff;
      @include transition;
      &:hover {
        color: #333;
        background: transparent;
      }
    }
    .dialog-empty-btn {
      cursor: pointer;
      padding: 5px 30px;
      @include border-radius;
      border: 1px solid transparent;
      color: #333;
      @include transition;
      &:focus {
        border: 1px solid transparent;
        background: transparent;
      }
      &:hover {
        border-color: transparent;
        color: $color-1;
        background: transparent;
      }
    }
  }
}

.rs_popup_rp {
  .el-dialog {
    background: transparent !important;
  }
  .rp_header {
    color: #fff !important;
  }
  .el-dialog {
    max-width: 1200px;
    @include border-radius(25px);
    overflow: hidden;
  }
  .el-dialog__header,
  .el-dialog__body {
    @extend .grad;
  }
  .el-dialog__body {
    padding-top: 5px;
  }
  .el-dialog__close {
    color: #fff;
    @include transition;
    opacity: .7;
    &:hover {
      color: #fff;
      opacity: 1;
    }
  }
}

// ObjectTeaser
.object-teaser_otr {
  margin: 20px 0;
  padding: 30px 30px 25px;
  border-radius: 10px;
  min-height: 55px;
  position: relative;
  overflow: hidden;
  @media (max-width: 800px) {
    padding: 20px;
  }
  &.otr_task {
    cursor: pointer;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 10px;
      bottom: 0;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      background: #4561ff;
      background: -moz-linear-gradient(top, #4561ff 0%, #ef446b 100%);
      background: -webkit-linear-gradient(top, #4561ff 0%,#ef446b 100%);
      background: linear-gradient(to bottom, #4561ff 0%,#ef446b 100%);
      filter: progid:DXImageTransform.Microsoft.gradient(
          startColorstr='#4561ff', endColorstr='#ef446b',GradientType=0);
    }
  }
  &.otr_task-fail {
    &:before {
      background: #b82121;
    }
  }
  .otr_wrap {
    position: relative;
    padding-left: 70px;
    padding-right: 220px;
    @media (max-width: 800px) {
      padding-right: 0;
    }
    @media (max-width: 500px) {
      padding-left: 0;
    }
  }
  .otr_icon {
    position: absolute;
    left: -2px;
    top: 0;
    width: auto;
    height: 50px;
    @media (max-width: 500px) {
      position: relative;
      margin: 5px auto 20px;
      display: block;
    }
  }
  .otr_title {
    font-size: 18px;
    line-height: 20px;
    margin: 0 0 10px;
    padding: 0;
    font-weight: normal;
    &.otr_title--object {
      cursor: pointer;
    }
    &.otr_title--task {
      cursor: pointer;
    }
  }
  .otr_info {
    .otr_info-el {
      font-size: 15px;
      display: inline-block;
      margin-right: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      max-width: 400px;
      cursor: help;
      color: #aaa;
      &.otr_authors {
        color: #fff;
      }
      @media (max-width: 800px) {
        max-width: 240px;
      }
    }
  }
  .otr_object-stat_oos {
    position: absolute;
    top: 0;
    right: 0;
    height: 40px;
    text-align: right;
    .oos_el {
      display: inline-block;
      margin-left: 15px;
      font-size: 12px;
      padding: 5px 0 0 30px;
      height: 30px;
      vertical-align: top;
      position: relative;
      background: transparent;
      border: none;
      color: #aaa;
      &:before {
        content: '';
        width: 24px;
        height: 23px;
        float: left;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .oos_likes:before {
      background: 0 0 no-repeat url(/static/grx/icons/heart.svg);
    }
    .oos_comments:before {
      background: 0 0 no-repeat url(/static/grx/icons/comment.svg);
    }
    .oos_reviews:before {
      background: 0 0 no-repeat url(/static/grx/icons/review.svg);
    }
    .oos_bookmarked {
      padding-left: 18px;
      display: none;
      &:before {
        background: 0 0 no-repeat url(/static/grx/icons/star.svg);
      }
      &.bookmarked_visible {
        display: inline-block;
      }
    }
    .el-dropdown-link {
      display: block;
      font-size: 20px;
      margin-top: 5px;
      width: 30px;
      height: 20px;
      outline: none !important;
      color: #fff;
    }
    @media (max-width: 800px) {
      position: static;
      height: 30px;
      margin-top: 10px;
      br {
        display: none;
      }
      .oos_el {
        margin-left: 20px;
      }
      .el-dropdown {
        margin: -3px 0 0 10px;
      }
    }
  }
  .otr_task-status {
    position: absolute;
    top: 0;
    right: 0;
    text-align: right;
  }
}

.el-notification__content {
  text-align: left;
}

.info-anchor_ina {
  margin-left: 10px;
  &.ina--always-white {
    color: #fff;
  }
}

.el-autocomplete-suggestion__wrap {
  border-radius: 0;
}

.nowrap {
  white-space: nowrap;
}


.licenses_lic {
  position: relative;
  padding-left: 70px;
  .lic_icon {
    width: 50px;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
  }
  .lic_title {
    line-height: 22px !important;
    margin-bottom: 5px !important;
  }
  .lic_desc {
    margin: 5px 0 15px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  @media (max-width: 450px) {
    padding-left: 0;
    .lic_icon {
      position: static;
      float: left;
      margin-right: 10px;
    }
    .lic_title {
      line-height: 22px !important;
      margin-bottom: 5px !important;
    }
    .lic_desc {
      margin: 5px 0;
    }
  }
}

.vivid-lnk {
  margin-top: 15px;
  font-size: 15px;
  color: lighten($color-2, 10%) !important;
  border-bottom: 1px dotted lighten($color-2, 10%);
  cursor: pointer;
  @include transition;
  line-height: 13px;
  &:hover {
    color: $color-1;
    border-bottom: 1px dotted transparent;
  }
}

.el-pagination__editor.el-input {
  .el-input__inner {
    font-size: 14px;
    height: 25px;
    padding-top: 1px;
  }
}

.el-date-table td.current:not(.disabled) span {
  color: #FFF;
  background-color: $color-2;
}

.help-link {
  display: block;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  opacity: 0.4;
  margin: 0 auto;
  width: max-content;
  &:hover {
    text-decoration: underline;
    opacity: 1;
    transition: opacity 0.3s;
  }
  &:before {
    content: '';
    width: 15px;
    height: 15px;
    display: inline-block;
    background: url(../static/grx/icons/help_ls.svg) no-repeat;
    vertical-align: -2px;
  }
  &:after {
    content: '';
    width: 15px;
    height: 15px;
    display: inline-block;
    background: url(../static/grx/icons/help_rs.svg) no-repeat;
    vertical-align: -2px;
  }
}

.object-search-form_osf {
  a.help-link {
    color: #000!important;
  }
}

.el-dialog {
  .el-dialog__body {
    a.help-link {
      color: #000!important;
    }
  }
}

.help-link_pcr {
  padding: 10px 25px 0px 25px;
  margin: 0 auto;
}

@import "./styles/themes/b";
@import "./styles/themes/w";
</style>



// WEBPACK FOOTER //
// src/App.vue